import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { 
  Users, 
  Activity, 
  Clock, 
  Battery, 
  Bell, 
  CheckCircle, 
  XCircle, 
  AlertTriangle 
} from 'lucide-react';

interface StatsProps {
  totalUsers: number;
  activeUsers: number;
  averageEnergy: number;
  alertsToday: number;
}

export function AdminStats({ 
  totalUsers, 
  activeUsers, 
  averageEnergy, 
  alertsToday 
}: StatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card className="hover:shadow-lg transition-all">
        <CardContent className="p-6">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-blue-100 rounded-lg">
              <Users className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Utilisateurs</p>
              <div className="flex items-baseline gap-2">
                <p className="text-2xl font-bold">{totalUsers}</p>
                <span className="text-sm text-green-600">
                  {activeUsers} actifs
                </span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="hover:shadow-lg transition-all">
        <CardContent className="p-6">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-green-100 rounded-lg">
              <Battery className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Énergie moyenne</p>
              <p className="text-2xl font-bold">{averageEnergy}%</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="hover:shadow-lg transition-all">
        <CardContent className="p-6">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-orange-100 rounded-lg">
              <Bell className="w-6 h-6 text-orange-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Alertes aujourd'hui</p>
              <p className="text-2xl font-bold">{alertsToday}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="hover:shadow-lg transition-all">
        <CardContent className="p-6">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-purple-100 rounded-lg">
              <Activity className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Taux d'activité</p>
              <p className="text-2xl font-bold">
                {Math.round((activeUsers / totalUsers) * 100)}%
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}